import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var TaskTile = require("components/utility/TaskTile");
var Spinner = require("components/utility/Spinner");

var CurrentUser = require("lib/account/CurrentUser");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var MyShelfRouting = require("lib/routing/MyShelfRouting");

@connect(
	(state, props) => ({
		revisables: ReadingSelectors.booksWithRevisables({
			state, conditions: { userID: CurrentUser.get().id }
		}),

		assignedTitles: ReadingSelectors.assignedTitleBooks({ state, userID: CurrentUser.get().id }),
		assignedURLs: ReadingSelectors.assignedURLBooks({ state, userID: CurrentUser.get().id }),
		assignedActivities: WritingSelectors.assignedActivities({ state, userID: CurrentUser.get().id })
	}),

	(dispatch, props) => ({
		populateData: (startDate, endDate) => {
			dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true }));
			return dispatch((dispatch, getState) => {

				// This only works because the tasks are already loaded in before this component mounts
				// It's not very stable. Or elegant.

				var readingTasks = WritingSelectors.teacherPicksTasks({ 
					state: getState(), filters: { user_id: CurrentUser.get().id }
				});

				if (readingTasks.length > 0) {
					return dispatch(ReadingActions.fetchBooks({
						ids: _.pluck(readingTasks, "subject_id"),
						user_id: CurrentUser.get().id,
						cache: true,
						query: { library_content: true }
					}))
				} else {
					return Promise.resolve();
				}
			})
		}
	})
)
@providePopulateData()
class StudentTasks extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onRevisionClick(item) {
		if (item.type == "quiz") {
			var detailsView = "quizzes"

		} else if (item.type == "answer") {
			var detailsView = "answers"

		} else if (item.type == "review") {
			var detailsView = "reviews"
		}

		$wr.redirect(MyShelfRouting.getPath({
			activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
			textID: item.text_id,
			detailsView
		}));

	}


	render() {
		var revisableQuizTasks = [];
		var revisableAnswerTasks = [];
		var revisableReviewTasks = [];

		var activityTasks = [];
		var bookTasks = [];
		var urlTasks = [];

		_.each(this.props.revisables, (item) => {

			var tile = (
				<TaskTile key={ item.text_id + ":" + item.type }
					onClick={ this.onRevisionClick }
					item={ item } type={ TaskTile.REVISABLE_TASK } />
			)

			if (item.type === "quiz") {
				revisableQuizTasks.push(tile);
			} else if (item.type === "answer") {
				revisableAnswerTasks.push(tile);
			} else if (item.type === "review") {
				revisableReviewTasks.push(tile);
			} else {
				console.error("Unkonwn revisable-task item type: ", tile.type);
			}
		})

		_.each(this.props.assignedActivities, (activity, index) => {
			var onClick = () => this.props.onActivitySelect(
				activity.id, activity.format_summary.text_completion
			);
			activityTasks.push(
				<TaskTile item={ activity } key={ index } type={ TaskTile.EXERCISE_TASK }
					onClick={ onClick } />
			);
		});

		_.each(this.props.assignedURLs, (book, index) => {
			urlTasks.push(
				<TaskTile item={ book } key={ index }
					type={ TaskTile.READING_URL_TASK } onClick={ this.props.onPickSelect } />
			);
		});

		_.each(this.props.assignedTitles, (book, index) => {
			bookTasks.push(
				<TaskTile item={ book } key={ index }
					type={ TaskTile.READING_TITLE_TASK } onClick={ this.props.onPickSelect } />
			);
		});

		return (
			<div className="studentTasksContainer">
				<p className="subHeader">My Tasks</p>

				<div className="studentTasks">
					{ revisableQuizTasks }
					{ revisableAnswerTasks }
					{ revisableReviewTasks }
					{ activityTasks }
					{ urlTasks }
					{ bookTasks }
				</div>
			</div>
		);
	}
};

StudentTasks.WrappedComponent.propTypes = StrictPropTypes({
	onPickSelect: PropTypes.func,
	onActivitySelect: PropTypes.func,

	// Data from @connect
	revisables: PropTypes.array,
	assignedActivities: PropTypes.array,
	assignedTitles: PropTypes.array,
	assignedURLs: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func,
});

module.exports = StudentTasks;


// WEBPACK FOOTER //
// ./modules/components/users/students/StudentTasks.js